import { APP_CONSTANTS } from "../../core/config/appConstants";

const rewriteRelativeLinks = (html) => {
	const baseUrl = APP_CONSTANTS.LINK.TELEKOM;
	return html.replace(
		/href=(['"])(\/[^'"]+)\1/gi,
		(match, quote, path) => {
			return `href=${quote}${baseUrl}${path}${quote}`;
		}
	);
};

const HeaderFooterUtils = {
	rewriteRelativeLinks
};

export default HeaderFooterUtils;
